import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { getAllOrderLineByOrderIdAsync } from '@application/features/orderlines/orderLineThunk';
import { useAppDispatch, useAppSelector } from '@application/store/useStore';
import { useEffect, useState } from 'react';
const PurchaseInvoiceLineViewTable = ({ formData, handleFieldChange, isPurchaseInvoiceLineTabBold }) => {
    const dispatch = useAppDispatch();
    const [gridCalculations, setGridCalculations] = useState();
    const { calculations } = useAppSelector((state) => state.calculation);
    const { SelectedCalculationForPurchaseInvoice } = useAppSelector((state) => state.order);
    const { orderLines } = useAppSelector((state) => state.orderLine);
    // useEffect(() => {
    //     if (SelectedCalculationForPurchaseInvoice == null) {
    //         dispatch(getAllOrderLineByOrderIdAsync(formData.orderId)).unwrap().then((res:CalculationDto[]) => {
    //             const mappedCalculations = mapCalculationsDtoToPurchaseInvoiceLineDtoList(res!);
    //             setGridCalculations(res);
    //             console.log(res,"from null");
    //             handleFieldChange('calculations', null);
    //             handleFieldChange('syncInvoiceLinetoPurchaseInvoiceLine', false);
    //             calculatePurchaseInvoice(mappedCalculations);
    //             if(isPurchaseInvoiceLineTabBold && res.length>0){
    //                 isPurchaseInvoiceLineTabBold(true)
    //             }
    //             else{
    //                 isPurchaseInvoiceLineTabBold && isPurchaseInvoiceLineTabBold(false)
    //             }
    //         });
    //     }
    // }, [formData.orderId]);
    // useEffect(() => {
    //     if (SelectedCalculationForPurchaseInvoice) {
    //         const mappedCalculations = mapCalculationsDtoToPurchaseInvoiceLineDtoList(SelectedCalculationForPurchaseInvoice);
    //         setGridCalculations(SelectedCalculationForPurchaseInvoice);
    //         console.log(SelectedCalculationForPurchaseInvoice,"from not null");
    //         handleFieldChange('calculations', mappedCalculations);
    //         handleFieldChange('syncInvoiceLinetoPurchaseInvoiceLine', true);
    //         calculatePurchaseInvoice(mappedCalculations);
    //         if(isPurchaseInvoiceLineTabBold && SelectedCalculationForPurchaseInvoice.length>0){
    //             isPurchaseInvoiceLineTabBold(true)
    //         }
    //         else{
    //             isPurchaseInvoiceLineTabBold && isPurchaseInvoiceLineTabBold(false)
    //         }
    //     }
    // }, [SelectedCalculationForPurchaseInvoice]);
    useEffect(() => {
        const dataKey = new URLSearchParams(window.location.search).get('dataKey');
        if (dataKey) {
            const storedData = localStorage.getItem(dataKey);
            if (storedData) {
                const { calculations } = JSON.parse(storedData);
                const mappedCalculations = mapCalculationsDtoToPurchaseInvoiceLineDtoList(calculations);
                setGridCalculations(calculations);
                handleFieldChange('calculations', mappedCalculations);
                handleFieldChange('syncInvoiceLinetoPurchaseInvoiceLine', true);
                calculatePurchaseInvoice(mappedCalculations);
                if (isPurchaseInvoiceLineTabBold) {
                    isPurchaseInvoiceLineTabBold(calculations.length > 0);
                }
            }
        }
        else {
            // Existing API fallback
            dispatch(getAllOrderLineByOrderIdAsync(formData.orderId))
                .unwrap()
                .then((res) => {
                const mappedCalculations = mapCalculationsDtoToPurchaseInvoiceLineDtoList(res);
                setGridCalculations(res);
                handleFieldChange('calculations', mappedCalculations);
                handleFieldChange('syncInvoiceLinetoPurchaseInvoiceLine', false);
                calculatePurchaseInvoice(mappedCalculations);
                if (isPurchaseInvoiceLineTabBold) {
                    isPurchaseInvoiceLineTabBold(res.length > 0);
                }
            });
        }
    }, [formData.orderId, SelectedCalculationForPurchaseInvoice, dispatch]);
    function calculatePurchaseInvoice(purchaseInvoiceLines) {
        if (purchaseInvoiceLines) {
            const total = purchaseInvoiceLines.reduce((acc, amount) => {
                const itemTotal = (amount.quantity * amount.netPrice).toFixed(2);
                return acc + parseFloat(itemTotal);
            }, 0);
            const inclusiveTotalAmount = total * 1.21;
            handleFieldChange('invoiceAmountExclVAT', total);
            handleFieldChange('invoiceAmountInclVAT', inclusiveTotalAmount);
        }
    }
    function mapCalculationsDtoToPurchaseInvoiceLineDtoList(calculations) {
        return calculations?.map(calculation => ({
            purchaseInvoiceId: null,
            orderLineId: calculation.orderLineId,
            usedMaterialsId: null,
            position: calculation.position,
            articleId: calculation.articleId,
            articleNumber: calculation.articleNumber,
            name: calculation.name,
            brand: calculation.brand,
            type: calculation.type,
            data: calculation.details,
            supplierArticleNumber: calculation.supplierProductNumber,
            quantity: calculation.quantity,
            unit: calculation.unit,
            workOrderId: calculation.workOrderId,
            grossPrice: calculation.unitPrice,
            discount: calculation.discount,
            netPrice: calculation.netPrice,
            sellingPrice: calculation.sellingPrice,
            received: calculation.received
        }));
    }
    return (_jsx(_Fragment, { children: _jsx("div", { className: 'custom-table-container mt-5', children: _jsx("div", { className: 'vn-table-container', children: _jsx("div", { className: 'vn-purchase-invoice-line-main', children: _jsxs("table", { className: 'table', children: [_jsx("thead", { className: 'vn-table-thead', children: _jsxs("tr", { className: 'vn-custom-grid-header-card', children: [_jsx("th", { children: _jsx("span", { className: 'header-caption', children: "#" }) }), _jsx("th", { children: _jsx("span", { className: 'header-caption', children: "Werkorder" }) }), _jsx("th", { children: _jsx("span", { className: 'header-caption', children: "Artikel nr" }) }), _jsx("th", { children: _jsx("span", { className: 'header-caption', children: "Naam" }) }), _jsx("th", { children: _jsx("span", { className: 'header-caption', children: "Merk" }) }), _jsx("th", { children: _jsx("span", { className: 'header-caption', children: "Type" }) }), _jsx("th", { children: _jsx("span", { className: 'header-caption', children: "Gegevens" }) }), _jsx("th", { children: _jsx("span", { className: 'header-caption', children: "Artikelnr Leverancier" }) }), _jsx("th", { children: _jsx("span", { className: 'header-caption', children: "Aantal" }) }), _jsx("th", { children: _jsx("span", { className: 'header-caption', children: "Totaalbedrag(\u20AC)" }) })] }) }), _jsx("tbody", { className: 'vn-table-tbody', children: gridCalculations &&
                                    gridCalculations?.map((calculation, index) => (_jsxs("tr", { style: { cursor: 'pointer' }, children: [_jsx("td", { className: 'pt-4', children: _jsx("span", { children: index + 1 }) }), _jsx("td", { className: 'pt-4', children: _jsx("span", { children: calculation.workOrderNumber }) }), _jsx("td", { className: 'pt-4', children: _jsx("span", { children: calculation.articleNumber }) }), _jsx("td", { className: 'pt-4', children: _jsx("span", { children: calculation.name }) }), _jsx("td", { className: 'pt-4', children: _jsx("span", { children: calculation.brand }) }), _jsx("td", { className: 'pt-4', children: _jsx("span", { children: calculation.type }) }), _jsx("td", { className: 'pt-4', children: _jsx("span", { children: calculation.details }) }), _jsx("td", { className: 'pt-4', children: _jsx("span", { children: calculation.supplierProductNumber }) }), _jsx("td", { className: 'pt-4', children: _jsx("span", { children: calculation.quantity?.toLocaleString('de-DE', {
                                                        minimumFractionDigits: 2,
                                                        maximumFractionDigits: 2
                                                    }) }) }), _jsx("td", { className: 'pt-4', children: _jsx("span", { children: (calculation.quantity * calculation.netPrice)?.toLocaleString('de-DE', {
                                                        minimumFractionDigits: 2,
                                                        maximumFractionDigits: 2
                                                    }) }) })] }, calculation.id))) })] }) }) }) }) }));
};
export default PurchaseInvoiceLineViewTable;
